import {useCallback, useMemo} from 'react'

import type {LayoutSettings, TableLayoutSettings} from '../api/view/contracts'

export function useDefaultLayoutSettingsForTable() {
  const getTableSettingsOrDefaults = useCallback((layoutSettings: LayoutSettings): TableLayoutSettings => {
    return {
      columnWidths: layoutSettings.table?.columnWidths ?? {},
      hierarchy: {
        enabled: layoutSettings.table?.hierarchy?.enabled ?? false,
      },
      agentAssignment: {
        visible: layoutSettings.table?.agentAssignment?.visible ?? true,
      },
    }
  }, [])

  return useMemo(
    () => ({
      getTableSettingsOrDefaults,
    }),
    [getTableSettingsOrDefaults],
  )
}
